import { useCallback } from 'react';
import { UiKitButton } from '@components/common/ui-kit-button';
import { ButtonGroup } from '@features/Unsubscribe/components/ButtonGroup';
import { Carousel } from '@features/Unsubscribe/components/Carousel';
import { Container } from '@features/Unsubscribe/components/Container';
import { Title } from '@features/Unsubscribe/components/Title';
import { useUnsubscribeAnalytics } from '@features/Unsubscribe/hooks/use-unsubscribe-analytics';
import type { TpWizardSteps } from '@features/Unsubscribe/types';
import { WIZARD_STEPS } from '../../сonstants';
import styles from './ToPause.module.scss';
export const ToPause = (props: TpWizardSteps) => {
  const {
    defaultEventOptions,
    trackUnsubscribeEvent
  } = useUnsubscribeAnalytics();
  const handlePauseClick = useCallback(() => {
    trackUnsubscribeEvent('cancel_pause_offer_chosen', {
      variant: '1-pause subscription'
    });
    props.wizard.goToStep(WIZARD_STEPS.FREEZED);
  }, [props.wizard, trackUnsubscribeEvent]);
  const handleCancel = useCallback(() => {
    trackUnsubscribeEvent('cancel_pause_offer_chosen', {
      variant: '2-cancel'
    });
    props.wizard.goToStep(WIZARD_STEPS.SPECIAL_OFFER);
  }, [props.wizard, trackUnsubscribeEvent]);
  return <Container className={styles.container} eventOnMounted="cancel_pause_offer_opened" eventOptions={defaultEventOptions} data-sentry-element="Container" data-sentry-component="ToPause" data-sentry-source-file="index.tsx">
      <Title data-sentry-element="Title" data-sentry-source-file="index.tsx">
        Are you sure? You can just <span className="highlight">freeze</span>{' '}
        your plan for 2 months
      </Title>

      <div className={styles.grouped}>
        <Carousel data-sentry-element="Carousel" data-sentry-source-file="index.tsx" />
      </div>

      <ButtonGroup data-sentry-element="ButtonGroup" data-sentry-source-file="index.tsx">
        <UiKitButton fullWidth onClick={handlePauseClick} data-sentry-element="UiKitButton" data-sentry-source-file="index.tsx">
          Pause my subscription
        </UiKitButton>
        <UiKitButton color="pure" onClick={handleCancel} data-sentry-element="UiKitButton" data-sentry-source-file="index.tsx">
          Cancel
        </UiKitButton>
      </ButtonGroup>
    </Container>;
};